import { ActivityItem } from "../components/types";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function formatCurrency(
  value: number | undefined | null,
  currency?: string,
  display?: "code" | "symbol"
) {
  try {
    if (value != null) {
      return value.toLocaleString("en-NG", {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        currencyDisplay: display || undefined,
      });
    } else {
      return "amount must be 200 above and less than 5,000,000";
    }
  } catch (e) {
   
    return "N/A";
  }
}



export function formatDateLong(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const formattedDate = date?.toLocaleString("en-US", options).toUpperCase();
  return formattedDate?.replace(",", "");
}

export function signOut() {
// Clear localStorage
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
}

export const getRandomGradient = (): string => {
  const gradients = [
    "#667eea, #764ba2",
    "#f093fb, #f5576c",
    "#4facfe, #00f2fe",
    "#43e97b, #38f9d7",
    "#ffecd2, #fcb69f",
    "#a8edea, #fed6e3",
    "#ff9a9e, #fecfef",
    "#ffeaa7, #fab1a0",
  ];
  return gradients[Math.floor(Math.random() * gradients.length)];
};

export const getBgColor = (type: ActivityItem["type"]) => {
  switch (type) {
    case "new":
      return "bg-blue-50";
    case "alert":
      return "bg-red-50";
    case "revenue":
      return "bg-green-50";
    case "system":
      return "bg-gray-50";
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "Active":
      return "bg-green-100 text-green-800";
    case "Completed":
      return "bg-blue-100 text-blue-800";
    case "Paused":
      return "bg-yellow-100 text-yellow-800";
    case "Draft":
      return "bg-gray-100 text-gray-800";
    case "Scheduled":
      return "bg-purple-100 text-purple-800";
    case "Failed":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getTypeColor = (type: any) => {
  switch (type) {
    case "Promotional":
      return "bg-pink-100 text-pink-800";
    case "Announcement":
      return "bg-blue-100 text-blue-800";
    case "Newsletter":
      return "bg-indigo-100 text-indigo-800";
    case "Retention":
      return "bg-orange-100 text-orange-800";
    case "Onboarding":
      return "bg-green-100 text-green-800";
    case "Urgent":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getStatusColors = (status: string): string => {
  switch (status) {
    case "APPROVED":
      return "green";
    case "PENDING":
      return "yellow";
    case "REJECTED":
      return "red";
    default:
      return "gray";
  }
};


export const getBarStatusColor = (status: string) => {
  switch (status) {
    case "active":
      return "bg-green-500";
    case "setup":
      return "bg-yellow-500";
    case "inactive":
      return "bg-gray-400";
    default:
      return "bg-blue-500";
  }
};

export const getTimeBasedGreeting = () => {
  const currentHour = new Date().getHours();
  
  if (currentHour >= 5 && currentHour < 12) {
    return "Good morning";
  } else if (currentHour >= 12 && currentHour < 17) {
    return "Good afternoon";
  } else if (currentHour >= 17 && currentHour < 21) {
    return "Good evening";
  } else {
    return "Good night";
  }
};


export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const FrontendURL = window.location.hostname.includes("dev.")
  ? "https://dev.api.connect.dalmlabs.com"
  : "https://api.connect.dalmlabs.com";

